var _path, _path2, _path3, _mask, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 240,
    viewBox: "0 0 347 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3933 235C75.6404 233.263 73.8966 232.141 71.9504 232.141L71.0589 232.17L70.9183 231.467C70.1308 227.538 66.5539 224.687 62.4133 224.687C58.1415 224.687 54.5447 227.644 53.8615 231.719L53.6974 232.699C53.2404 232.625 51.1896 231.467 48.8523 232.735L48 231.263C49.3078 230.554 50.8535 230.295 52.3339 230.551C53.5029 226.125 57.6013 223 62.4133 223C67.1477 223 71.2684 226.104 72.4702 230.474C74.9071 230.659 77.0429 232.138 78 234.348L76.3933 235Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7448 237L32 236.528C34.2183 227.822 45.6225 226.23 50 234.06L48.4374 234.988C44.864 228.596 35.5539 229.895 33.7448 237Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.127 135H269.874C269.624 135 269.385 134.892 269.22 134.703C269.054 134.514 268.976 134.263 269.006 134.012C269.681 128.444 274.388 124.244 279.952 124.244C281.309 124.244 282.66 124.5 283.923 124.99C284.693 116.059 292.188 109 301.212 109C310.786 109 318.575 116.855 318.575 126.509C318.575 126.704 318.562 126.895 318.55 127.086L318.492 128.231L316.747 128.147L316.788 127.267C316.793 127.166 316.799 127.066 316.806 126.966C316.817 126.814 316.828 126.663 316.828 126.509C316.828 117.826 309.822 110.762 301.212 110.762C292.697 110.762 285.696 117.75 285.606 126.339C285.602 126.647 285.44 126.931 285.178 127.088C284.915 127.245 284.59 127.253 284.321 127.108C282.983 126.387 281.472 126.006 279.952 126.006C275.605 126.006 271.88 129.052 270.914 133.238H336.108C335.122 128.336 330.846 124.751 325.79 124.751C325.471 124.751 325.154 124.766 324.847 124.793L323.977 124.872L323.821 123.117L324.692 123.038C325.05 123.006 325.42 122.989 325.79 122.989C332.07 122.989 337.317 127.733 337.995 134.024C338.022 134.273 337.943 134.521 337.777 134.708C337.611 134.894 337.374 135 337.127 135Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 70,
    width: 70,
    height: 26
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1864 70.0723H88.8797V95.7205H19.1864V70.0723Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9972 95.7205H20.0688C19.8161 95.7205 19.5755 95.6136 19.4082 95.4275C19.2403 95.2414 19.1623 94.9928 19.1929 94.7463C19.8748 89.253 24.6277 85.1105 30.2487 85.1105C31.6194 85.1105 32.9838 85.3626 34.2592 85.8464C35.0369 77.0356 42.6073 70.0723 51.7221 70.0723C61.3919 70.0723 69.2592 77.8209 69.2592 87.3447C69.2592 87.5364 69.2464 87.7248 69.2337 87.9132L69.1755 89.0426L67.4128 88.9605L67.4546 88.092C67.4594 87.993 67.4662 87.894 67.473 87.7949C67.4834 87.6456 67.4944 87.4964 67.4944 87.3447C67.4944 78.7791 60.4187 71.8105 51.7221 71.8105C43.1219 71.8105 36.0501 78.704 35.9591 87.1771C35.9555 87.4809 35.7918 87.761 35.5263 87.9156C35.2617 88.0704 34.9331 88.078 34.6614 87.9349C33.3094 87.2241 31.7837 86.8484 30.2487 86.8484C25.8571 86.8484 22.0949 89.8533 21.1197 93.9823H86.9683C85.9729 89.1466 81.6539 85.6106 76.5466 85.6106C76.2251 85.6106 75.9041 85.6246 75.5948 85.6518L74.7159 85.7292L74.5584 83.998L75.4373 83.9203C75.7991 83.8888 76.1726 83.8724 76.5466 83.8724C82.8902 83.8724 88.1903 88.5521 88.8746 94.7577C88.9013 95.0031 88.8215 95.2482 88.6539 95.4319C88.4866 95.616 88.2476 95.7205 87.9972 95.7205Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.438 231.139C289.543 225.271 279.913 228.102 279 235.724L280.768 235.936C280.991 234.08 281.921 232.423 283.388 231.269C287.449 228.073 293.578 230.244 294.572 235.451L296.322 235.116C296.152 234.227 295.848 233.391 295.439 232.624C297.717 231.495 300.536 232.41 301.651 234.754C301.655 234.764 302.08 235.794 302.234 237L304 236.775C303.245 230.848 298.033 229.186 294.438 231.139Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2289 237C98.8932 234.826 97.1329 233.126 94.8483 232.77C91.959 232.318 89.2395 234.18 88.7663 236.915L87 236.64C87.3071 234.867 88.3223 233.313 89.86 232.266C94.1438 229.345 100.226 231.742 101 236.753L99.2289 237Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82 238H84V199H82V238Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4989 216L83 215.223L87.5008 206L89 206.777L84.4989 216Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4476 218L80.5788 217.825C73.8698 216.478 69 210.612 69 203.88C69 199.67 71.8073 189.755 74.4152 182.323C78.2168 171.492 81.2733 166 83.4997 166C85.7267 166 88.7832 171.492 92.5851 182.323C95.193 189.755 98 199.67 98 203.88C98 210.261 93.6291 215.904 87.3707 217.601L86.5165 217.834L86.0435 216.156L86.8986 215.924C92.391 214.434 96.2266 209.481 96.2266 203.88C96.2266 200.56 94.0366 191.867 91.0194 183.209C87.2017 172.253 84.3709 167.907 83.4836 167.74C82.6288 167.907 79.7986 172.254 75.9806 183.209C72.9634 191.867 70.7734 200.56 70.7734 203.88C70.7734 209.789 75.0465 214.937 80.9344 216.119L81.8032 216.294L81.4476 218Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 239H347V237H0V239Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.507 225.5H327.602V223.421H312.507V225.5ZM310.786 230H312.507V227.286H327.602V230H329.323V227.286H331V225.5H329.323V223.421H331V221.635H329.323V220H327.602V221.635H312.507V220H310.786V221.635H309V223.421H310.786V225.5H309V227.286H310.786V230Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337 231H309V232.747H310.818V238H312.569V232.747H316.978V238H318.729V232.747H327.931V238H329.683V232.747H334.193V238H335.944V232.747H337V231Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263 237H265V198H263V237Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 215L264 214.223L268.501 205L270 205.777L265.499 215Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.448 217L261.579 216.825C254.869 215.478 250 209.613 250 202.88C250 198.67 252.807 188.755 255.415 181.323C259.217 170.492 262.273 165 264.5 165C266.727 165 269.783 170.492 273.585 181.323C276.193 188.755 279 198.67 279 202.88C279 209.261 274.629 214.904 268.371 216.602L267.517 216.834L267.044 215.156L267.899 214.924C273.391 213.434 277.227 208.481 277.227 202.88C277.227 199.56 275.037 190.867 272.019 182.209C268.202 171.253 265.371 166.906 264.484 166.74C263.629 166.906 260.799 171.254 256.981 182.209C253.963 190.867 251.773 199.56 251.773 202.88C251.773 208.789 256.046 213.937 261.934 215.12L262.803 215.294L262.448 217Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 13,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 49,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 137,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 168,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 13,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 49,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 137,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 168,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 13,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 49,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 137,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 168,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 13,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 49,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 137,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 168,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 205,
    width: 22,
    height: 33,
    stroke: "black",
    strokeWidth: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 13,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 49,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 137,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 168,
    width: 15,
    height: 21,
    stroke: "black",
    strokeWidth: 2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 1,
    width: 126,
    height: 238,
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonError);
export default __webpack_public_path__ + "static/media/common_error.6979b4ed.svg";
export { ForwardRef as ReactComponent };